import React, { useState, useEffect } from "react";
import "./testsScreen.css";
import CustomButton from "../../common/customButton/customButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import courseImg from "../../assets/course-module-img.png";
import gcseImg from "../../assets/topBanner_a08.png";
import gcseLogo from "../../assets/KSOL GCSE_logo.png";
import tick from "../../assets/tick.png";
import { isMobile } from "react-device-detect";
import desktop from "../../assets/desktop.png";
import tablet from "../../assets/tablet.png";
import { useSharedState } from "../../context/formsContext";
import TestBox from "../../common/testBox/testBox";
import WordFromTutors from "../wordFromTutors/wordFromTutors";
import UniformLoader from "../../common/uniformLoader/uniformLoader";
import { getProperty } from "../../utils/apiResponseHelper";
import logo from "../../assets/ksolactipanel.png";
import logoWhite from "../../assets/Logo All White Larger-01.png";
import testOne from "../../assets/Maths-Paper-1-Cover_1.png";
import testTwo from "../../assets/Maths-Paper-2-Cover_1.png";
import testThree from "../../assets/Comprehension-Paper-Cover_1.png";
import testFour from "../../assets/NVR-Paper-Cover-1_1.png";
import testFive from "../../assets/NVR-Paper-2-Cover_1.png";
import testSix from "../../assets/Verbal-GL-Paper-Cover-New.png";
import testSeven from "../../assets/NVRSpatial-GL-Paper-Cover_1.png";
import testEight from "../../assets/TechnicalEnglishp-paper-cover-GL.png";
import { useLocation, useNavigate } from "react-router-dom";
import rightArrow from "../../assets/rightArrow.png";
import ChildRegistration from "../childRegistration/childRegistration";
import Modal from "../../common/modal/modal";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet-async";

const TestsScreen = () => {
  const [isGcse, setIsGcse] = useState(false);
  const {
    value,
    studentId,
    setStudentId,
    setTestData,
    testData,
    loginToken,
    setLoginToken,
    setLoading,
    loading,
    mentorId,
    setBackKeyDashboard,

    prefix,
  } = useSharedState(isGcse);

  const navigate = useNavigate();
  const location = useLocation();

  const [testBackClick, setTestBackClick] = useState(false);

  useEffect(() => {
    const handleLocationChange = () => {
      setBackKeyDashboard(true);
      setTestBackClick(true);
    };

    handleLocationChange();

    return () => {};
  }, [location]);

  useEffect(() => {
    if (isGcse) {
      document.body.classList.add("gcse-mode");
    } else {
      document.body.classList.remove("gcse-mode");
    }
  }, [isGcse]);

  const [closeLightbox, setCloseLightbox] = useState(() => {
    return localStorage.getItem("mobileLightboxClosed") === "true";
  });
  const [showTip, setShowTip] = useState(false);
  const [isFreeDownloads, setIsFreeDownloads] = useState(false);
  const [students, setStudents] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isFetchingStudents, setIsFetchingStudents] = useState(false);
  const [isFetchingTests, setIsFetchingTests] = useState(false);

  // Initialize: Restore data from localStorage and check course settings
  useEffect(() => {
    // Restore testData from localStorage on mount (for refresh persistence)
    const storedTestData = localStorage.getItem("testData");
    if (storedTestData) {
      try {
        const parsed = JSON.parse(storedTestData);
        if (parsed && Array.isArray(parsed) && parsed.length > 0) {
          setTestData(parsed);
        }
      } catch (e) {
        localStorage.removeItem("testData");
      }
    }

    // Restore studentId from localStorage
    const storedStudentId = localStorage.getItem("studentId");
    if (storedStudentId) {
      setStudentId(Number(storedStudentId));
    }

    // Check for course parameter or hostname on mount
    const params = new URLSearchParams(window.location.search);
    const course = params.get("course");
    const hostname = window.location.hostname;

    // Check if course is explicitly set in URL or if domain is ksolgcse.co.uk
    if (course === "gcse" || hostname.includes("ksolgcse.co.uk")) {
      localStorage.setItem("gcse", "true");
      setIsGcse(true);
      localStorage.setItem("isGcse", "true");
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (window.location.pathname.includes("/dashboard")) {
      const sessionLoginToken = localStorage.getItem("loginToken");

      if (!sessionLoginToken && !testData) {
        setTimeout(() => {
          navigate("/loginScreen");
        }, 2000);
      }
    }
  }, [testData, navigate]);

  const setFreeDownloadsBackground = () => {
    if (isFreeDownloads) {
      return "green-bg-selected text-white   h-12";
    } else {
      return "green-bg  h-10";
    }
  };

  const setFreeDownloadsBackgroundGcse = () => {
    if (isFreeDownloads) {
      return "gcse-bg-selected text-white   h-12";
    } else {
      return "gcse-bg  h-10";
    }
  };

  const setFiveMinuteTestBackground = () => {
    if (!isFreeDownloads) {
      return "orange-bg-selected text-white  h-12";
    } else {
      return "orange-bg  h-10";
    }
  };

  const setFiveMinuteTestBackgroundGcse = () => {
    if (!isFreeDownloads) {
      return "gcse-bg-selected text-white  h-12";
    } else {
      return "gcse-bg  h-10";
    }
  };

  const freePapers = [
    {
      type: "maths",
      id: 1,
      name: "KSOL 11+ Practice Papers | Maths Paper 1 - Suitable for the 11+ GL Assessment",
      img: testOne,
    },
    {
      type: "maths",
      id: 2,
      name: "KSOL 11+ Practice Papers | Maths Paper 2 - Suitable for the 11+ GL Assessment",
      img: testTwo,
    },
    {
      type: "english",
      id: 3,
      name: "KSOL 11+ Practice Papers | Comprehension - Suitable for the 11+ GL Assessment",
      img: testThree,
    },
    {
      type: "nonVerbal",
      id: 4,
      name: "KSOL 11+ Practice Papers | Non-Verbal Reasoning Paper 1 - Suitable for the 11+ GL Assessment",
      img: testFour,
    },
    {
      type: "nonVerbal",
      id: 5,
      name: "KSOL 11+ Practice Papers | Non-Verbal Reasoning Paper 2 - Suitable for the 11+ GL Assessment",
      img: testFive,
    },
    {
      type: "verbal",
      id: 6,
      name: "KSOL 11+ Practice Papers | Verbal Reasoning - Suitable for the 11+ GL Assessment ",
      img: testSix,
    },
    {
      type: "nonVerbal",
      id: 7,
      name: "KSOL 11+ Practice Papers | NVR Spatial Reasoning - Suitable for the 11+ GL Assessment ",
      img: testSeven,
    },
    {
      type: "english",
      id: 8,
      name: "KSOL 11+ Practice Paper | Technical English Paper - Suitable for the 11+ GL Assessment ",
      img: testEight,
    },
  ];

  // Helper function to map API quizTitle to paper image and type
  const mapQuizToPaper = (quizTitle) => {
    if (!quizTitle) return { img: testOne, type: "maths" };
    
    const titleLower = quizTitle.toLowerCase();
    let img = testOne; // default
    let type = "maths"; // default
    
    if (titleLower.includes("maths")) {
      img = testOne;
      type = "maths";
    } else if (titleLower.includes("english")) {
      img = testThree;
      type = "english";
    } else if (titleLower.includes("verbal")) {
      img = testSix;
      type = "verbal";
    } else if (titleLower.includes("nvr")) {
      img = testFour;
      type = "nonVerbal";
    }
    
    return { img, type };
  };

  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
  }

  const handleCloseLightbox = () => {
    setCloseLightbox(true);
    localStorage.setItem("mobileLightboxClosed", "true");
  };

  const width = useWindowWidth();
  const [showMobileLightbox, setShowMobileLightbox] = useState(isMobile);

  useEffect(() => {
    const mobileWidthThreshold = 600;
    setShowMobileLightbox(width <= mobileWidthThreshold);
  }, [width]);

  const getTestProgress = (test) => {
    if (!test) return "notStarted";
    const startTime = getProperty(test, 'startTime') || getProperty(test, 'StartTime') || test?.StartTime || test?.startTime || '';
    const endTime = getProperty(test, 'endTime') || getProperty(test, 'EndTime') || test?.EndTime || test?.endTime || '';
    
    if (!startTime) {
      return "notStarted";
    } else if (startTime && !endTime) {
      return "inProgress";
    } else if (endTime) {
      return "finished";
    }
    return "unknown";
  };

  const selectStudent = async () => {
    // Prevent multiple simultaneous calls
    if (isFetchingStudents) {
      return;
    }

    const sessionLoginToken = localStorage.getItem("loginToken");
    const sessionMentorId = localStorage.getItem("mentorId");

    const token = sessionLoginToken || loginToken;
    const mentorIdToUse = sessionMentorId || mentorId;
    
    if (token && mentorIdToUse && !isFetchingStudents) {
      setIsFetchingStudents(true);
      try {
        const response = await fetch(
          `${prefix}/api-40/api40/Account/GetMentorStudents?MentorId=${mentorIdToUse}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch");
        }

        const data = await response.json();

        const studentList = data.map((child) => {
          const firstName = getProperty(child, 'firstname') || getProperty(child, 'FirstName') || getProperty(child, 'Firstname') || child?.FirstName || child?.Firstname || child?.firstname || '';
          const lastName = getProperty(child, 'lastname') || getProperty(child, 'LastName') || getProperty(child, 'Lastname') || child?.LastName || child?.Lastname || child?.lastname || '';
          const studentId = getProperty(child, 'studentId') || getProperty(child, 'StudentId') || child?.StudentId || child?.studentId;
          return {
            label: `${firstName} ${lastName}`.trim(),
            value: studentId,
          };
        });

        setStudents(studentList);
        
        // Only set first student if no studentId is currently set
        if (!studentId && data[0]) {
          const firstStudentId = getProperty(data[0], 'studentId') || getProperty(data[0], 'StudentId') || data[0]?.StudentId || data[0]?.studentId;
          if (firstStudentId) {
            setStudentId(firstStudentId);
            localStorage.setItem("studentId", firstStudentId);
          }
        }
      } catch (error) {
      } finally {
        setIsFetchingStudents(false);
      }
    }
  };

  // Fetch students when initialized and we have loginToken/mentorId
  useEffect(() => {
    if (isInitialized) {
      const sessionLoginToken = localStorage.getItem("loginToken");
      const sessionMentorId = localStorage.getItem("mentorId");
      const token = sessionLoginToken || loginToken;
      const mentorIdToUse = sessionMentorId || mentorId;
      
      if (token && mentorIdToUse && students.length === 0 && !isFetchingStudents) {
        selectStudent();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, loginToken, mentorId, students.length]);

  // Set first student if students are loaded but no studentId is set
  useEffect(() => {
    if (students.length > 0 && !studentId) {
      const firstStudentId = students[0].value;
      setStudentId(firstStudentId);
      localStorage.setItem("studentId", firstStudentId);
    }
  }, [students, studentId]);

  useEffect(() => {
    if (testData && testData.length > 0) {
      // Check if GCSE was set via URL/hostname - if so, preserve it
      const gcseFromUrl = localStorage.getItem("gcse") === "true";
      const hostname = window.location.hostname;
      const params = new URLSearchParams(window.location.search);
      const course = params.get("course");
      const isGcseFromUrlOrHost = gcseFromUrl || course === "gcse" || hostname.includes("ksolgcse.co.uk");

      // Check course code to determine if it's GCSE or Free Downloads
      const courseCode = getProperty(testData[0], 'courseCode') || getProperty(testData[0], 'CourseCode') || testData[0]?.CourseCode || testData[0]?.courseCode || '';
      
      if (courseCode === "[FDL-GCSE]") {
        setIsGcse(true);
        localStorage.setItem("isGcse", "true");
        setIsFreeDownloads(true);
      } else if (isGcseFromUrlOrHost) {
        // Preserve GCSE setting if it was set via URL/hostname
        setIsGcse(true);
        localStorage.setItem("isGcse", "true");
        // Check if it's free downloads based on course code pattern
        if (courseCode && courseCode.startsWith("[FDL-")) {
          setIsFreeDownloads(true);
        }
      } else {
        setIsGcse(false);
        localStorage.setItem("isGcse", "false");
        // Auto-detect free downloads based on course code pattern (FDL-YR3, FDL-YR4, etc.)
        if (courseCode && courseCode.startsWith("[FDL-")) {
          setIsFreeDownloads(true);
        } else {
          setIsFreeDownloads(false);
        }
      }
    }
  }, [testData]);

  const getTestData = async () => {
    // Prevent multiple simultaneous calls
    if (isFetchingTests) {
      return;
    }

    const sessionLoginToken = localStorage.getItem("loginToken");
    const sessionStudentId = localStorage.getItem("studentId");

    const token = sessionLoginToken || loginToken;
    const studentIdToUse = sessionStudentId || studentId;

    if (token && studentIdToUse && !isFetchingTests) {
      setIsFetchingTests(true);
      try {
        // Check if there's an active quiz session - if so, preserve testData
        const activeQuizSummaryId = localStorage.getItem("quizSummaryId");
        const hasActiveQuiz = activeQuizSummaryId && activeQuizSummaryId !== "undefined" && activeQuizSummaryId !== "null";
        
        // Only clear testData if we're fetching for a different student AND there's no active quiz
        const storedTestData = localStorage.getItem("testData");
        if (storedTestData && !hasActiveQuiz) {
          try {
            const parsed = JSON.parse(storedTestData);
            const storedStudentId = parsed[0] ? (getProperty(parsed[0], 'studentId') || parsed[0].StudentId || parsed[0].studentId) : null;
            // Only clear if studentId changed
            if (storedStudentId && Number(storedStudentId) !== Number(studentIdToUse)) {
              setTestData([]);
              localStorage.removeItem("testData");
            }
          } catch (e) {
            // If parsing fails, clear it (but only if no active quiz)
            setTestData([]);
            localStorage.removeItem("testData");
          }
        } else if (storedTestData && hasActiveQuiz) {
          // If there's an active quiz, restore testData from localStorage to ensure continuity
          try {
            const parsed = JSON.parse(storedTestData);
            if (parsed && Array.isArray(parsed) && parsed.length > 0) {
              setTestData(parsed);
            }
          } catch (e) {
          }
        }

        const response = await fetch(
          `${prefix}/api-40/api40/Quiz/GetDownloadDashboard?StudentId=${studentIdToUse}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch");
        }

        const data = await response.json();

        // Only update if we got valid data
        if (data && Array.isArray(data)) {
          localStorage.setItem("testData", JSON.stringify(data));
          setTestData(data);
        }
      } catch (error) {
        try {
          await fetch(`${prefix}/api-40/Log/Log`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionLoginToken}`,
              "X-API-Key": "8dnd6%3258%&k+_FsaTK25SCBNE58*t9"
            },
            body: JSON.stringify({
              Message: `Error fetching test data: ${error.message}`,
              Time: new Date().toISOString(),
            }),
          });
        } catch (logError) {
        }
      } finally {
        setIsFetchingTests(false);
      }
    } else {
    }
  };

  // Clean up quiz-related localStorage items on mount (but keep studentId and testData)
  useEffect(() => {
    localStorage.removeItem("curriculumId");
    localStorage.removeItem("quizIndex");
    localStorage.removeItem("quizSummaryId");
    localStorage.removeItem("timeRemaining");
    localStorage.removeItem("totalQuestions");
    localStorage.removeItem("previousTimeUsed");
    localStorage.removeItem("totalTime");
    localStorage.removeItem("testQuestions");
    // Don't remove studentId or isGcse - they need to persist
  }, []);

  // Set previous page and fetch test data when studentId changes
  useEffect(() => {
    localStorage.setItem("previousPage", "/dashboard");
    
    // Only fetch if we have a studentId and are initialized
    if (isInitialized && studentId) {
      getTestData();
    }
  }, [studentId, isInitialized]);

  // Set loading state based on whether we're fetching or have data
  useEffect(() => {
    if (isFetchingTests || isFetchingStudents) {
      setLoading(true);
    } else if (testData && testData.length > 0) {
      setLoading(false);
    } else if (studentId && !isFetchingTests && !isFetchingStudents) {
      // If we have a studentId but no testData and we're not fetching, we might be waiting
      // Only show loading if we don't have any cached data
      const storedTestData = localStorage.getItem("testData");
      if (!storedTestData) {
        setLoading(true);
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [testData, isFetchingTests, isFetchingStudents, studentId]);

  const takeToCourse = () => {
    ReactGA.event({
      category: "Recommended Product Click",
      action: "Click",
      label: "recommended_product_click",
    });

    if (testData && testData[0]) {
      const recommendedProductUrl = getProperty(testData[0], 'recommendedProductUrl') || getProperty(testData[0], 'RecommendedProductUrl') || testData[0]?.RecommendedProductUrl || testData[0]?.recommendedProductUrl || '';
      if (recommendedProductUrl) {
        window.open(
          recommendedProductUrl,
          "_blank",
          "noopener noreferrer"
        );
      }
    }
  };

  const handleLogOut = () => {
    localStorage.clear();
    navigate("/loginScreen");
  };

  if (loading) {
    return (
      <UniformLoader
        title="Loading..."
        message="Please wait while we load your dashboard"
        subMessage=""
      />
    );
  }

  return (
    <>
      <Helmet>
        <title>Dashboard | KSOL</title>
        <meta name="description" content="Access your KSOL dashboard to view available tests, practice papers, and track your child's 11+ preparation progress." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="w-full orange-bg text-white px-6  overflow-x-auto">
        <div className="flex items-center justify-center gap-8 min-w-max">
          <img
            className="w-36 shrink-0"
            src={isGcse ? gcseLogo : logoWhite}
            alt="Logo"
          />

          <span className="font-bold whitespace-nowrap">
            Over 20 years experience
          </span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">
            Qualified teachers
          </span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">
            Professionally written tests
          </span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">
            Explanations & feedback
          </span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">Smart analytics</span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">Instant results</span>
          <span className="hidden sm:inline-block">|</span>
          <span className="font-bold whitespace-nowrap">
            Free test paper downloads
          </span>
        </div>
      </div>
      <div className="relative-tests">
      {showMobileLightbox && !closeLightbox && (
        <div className="absolute inset-0 flex flex-col py-40 px-4 lightbox-bg-tests">
          <div className="bg-white rounded-3xl p-4 text-center">
            <h3 className="orange-bg text-white p-4 rounded-3xl">
              You Are on Mobile
            </h3>
            <p>
              You are about to experience the tests. This is best experienced on
              Tablet/Laptop or Desktop.
            </p>
            <div className="flex justify-center mt-4 gap-8">
              <img src={desktop} alt="desktop" />
              <img src={tablet} alt="tablet" />
            </div>
            <div className="mt-8 mb-2">
              <CustomButton
                onClick={handleCloseLightbox}
                text={"Continue"}
                type={isMobile ? "logOut" : ""}
                isGcse={isGcse}
              />
            </div>
          </div>
        </div>
      )}

      <div
        className={`p-10 flex flex-col items-center ${
          isGcse ? "bg-image-gcse" : "bg-image"
        } justify-start`}
      >
        <div className="flex justify-center items-center w-full  gap-6 mb-4">
          <div className="w-full lg:w-3/4 flex justify-center items-center">
            <div className="w-full flex items-end justify-center gap-4 flex-wrap lg:flex-nowrap">
              <div className="lg:hidden w-full flex items-center justify-center gap-6">
                <div className="flex w-1/2">
                  <img
                    src={isGcse ? gcseLogo : logo}
                    alt="logo"
                    className="w-56 h-auto"
                  />
                </div>
                <div className="lg:hidden flex flex-nowrap w-auto max-h-[50px]">
                  <CustomButton
                    onClick={() => {
                      handleLogOut();
                    }}
                    type={"logOut"}
                    text={"Log out"}
                    isGcse={isGcse}
                  />
                </div>
              </div>

              <div className="flex flex-col items-start flex-grow">
                <h3
                  className={
                    isGcse
                      ? " mb-2 whitespace-nowrap text-white"
                      : " mb-2 whitespace-nowrap"
                  }
                >
                  {isGcse ? "Select Student" : "Select Child"}
                </h3>
                <div className="relative flex flex-col lg:flex-row mb-4 items-center gap-4 w-full">
                  <div className="relative w-full lg:w-1/2">
                    {" "}
                    <select
                      id="studentDropdown"
                      className="appearance-none w-full p-2 border rounded pr-8"
                      value={studentId || ""}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        const student = students.find(
                          (s) => s.value === Number(selectedValue)
                        );

                        if (student) {
                          setStudentId(student.value);
                          localStorage.setItem("studentId", student.value);
                        }
                      }}
                    >
                      {students.map((student) => (
                        <option key={student.value} value={student.value}>
                          {student.label}
                        </option>
                      ))}
                    </select>
                    {/* Dropdown arrow */}
                    <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-600">
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="shrink-0">
                    <CustomButton
                      onClick={() => setShowModal(true)}
                      text={"Add Child"}
                      type={"logOut"}
                      isGcse={isGcse}
                    />
                  </div>
                </div>
              </div>

              <div className="hidden w-1/2 flex justify-end">
                <img
                  src={isGcse ? gcseLogo : logo}
                  alt="logo"
                  className="w-56 h-auto"
                />
              </div>
            </div>
          </div>

          <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
            <ChildRegistration addChildDashboard={true} isGcse={isGcse} />
          </Modal>
        </div>

        {studentId && (
          <>
            <div className="flex flex-col justify-between items-center  ml-auto mr-auto xl:w-3/4 xl:flex xl:flex-row">
              {!isFreeDownloads && (
                <h2
                  className={
                    isGcse
                      ? "flex-col items-end text-left mb-4 xl:flex xl:flex-row text-white leading-none "
                      : "flex-col items-end text-left mb-4 xl:flex xl:flex-row leading-none "
                  }
                >
                  {testData.length === 0 ? (
                    "No tests available for this child"
                  ) : (
                    <>
                      11 plus 5 minute tests for&nbsp;
                      <span className={isGcse ? "text-white" : "orange"}>
                        {getProperty(testData[0] || {}, 'childFirstName') || getProperty(testData[0] || {}, 'ChildFirstName') || testData[0]?.ChildFirstName || testData[0]?.childFirstName || ''}
                      </span>
                    </>
                  )}
                </h2>
              )}
              {isFreeDownloads && (
                <h2
                  className={
                    isGcse
                      ? "flex-col items-end text-left mb-4 xl:flex xl:flex-row text-white"
                      : "flex-col items-end text-left mb-4 xl:flex xl:flex-row"
                  }
                >
                  {testData.length === 0 ? (
                    "Free Downloads"
                  ) : (
                    <>
                      Free Downloads for &nbsp;
                      <span
                        className={isGcse ? "text-white" : "orange"}
                      >{` ${getProperty(testData[0] || {}, 'childFirstName') || getProperty(testData[0] || {}, 'ChildFirstName') || testData[0]?.ChildFirstName || testData[0]?.childFirstName || ''}`}</span>
                    </>
                  )}
                </h2>
              )}

              <div className="hidden lg:block flex justify-center mb-4 xl:justify-end">
                <CustomButton
                  onClick={() => {
                    handleLogOut();
                  }}
                  type={"logOut"}
                  text={"Log out"}
                  isGcse={isGcse}
                />
              </div>
            </div>
            <div className="flex w-full justify-center">
              <div className="hidden flex xl:flex xl:flex justify-center items-end xl:w-3/4">
                <div
                  onClick={() => setIsFreeDownloads(false)}
                  className={` xl:w-2/4 flex justify-center items-center ${
                    isGcse
                      ? setFiveMinuteTestBackgroundGcse()
                      : setFiveMinuteTestBackground()
                  } px-4 left-tab cursor-pointer`}
                >
                  <h3 className="text-white">5 Minute Tests</h3>
                </div>
                <div
                  onClick={() => setIsFreeDownloads((prevState) => !prevState)}
                  className={`xl:w-2/4 flex justify-center items-center ${
                    isGcse
                      ? setFreeDownloadsBackgroundGcse()
                      : setFreeDownloadsBackground()
                  } px-4 right-tab cursor-pointer`}
                >
                  <h3 className="text-white">Free Downloads</h3>
                </div>
              </div>
              <div className="flex-col xl:hidden w-full lg:w-auto">
                <div
                  onClick={() => setIsFreeDownloads(false)}
                  className={`flex justify-between items-center ${
                    isGcse
                      ? setFiveMinuteTestBackgroundGcse()
                      : setFiveMinuteTestBackground()
                  } px-4 left-tab-mobile cursor-pointer`}
                >
                  <h3 style={{ fontSize: "28px" }} className="text-white">
                    5 Minute Tests
                  </h3>
                  <img
                    style={{ height: "30px" }}
                    src={rightArrow}
                    alt="right arrow"
                  />
                </div>
                <div
                  onClick={() => setIsFreeDownloads((prevState) => !prevState)}
                  className={`flex justify-between items-center ${
                    isGcse
                      ? setFreeDownloadsBackgroundGcse()
                      : setFreeDownloadsBackground()
                  } px-4 right-tab-mobile cursor-pointer`}
                >
                  <h3 style={{ fontSize: "28px" }} className="text-white">
                    Free Downloads
                  </h3>
                  <img
                    style={{ height: "30px" }}
                    src={rightArrow}
                    alt="right arrow"
                  />
                </div>
              </div>
            </div>
            <div className=" w-full bg-white drop-shadow-lg border-radius-bottom ml-auto mr-auto xl:w-3/4">
              {!isFreeDownloads && (
                <p className="p-4">
                  {isGcse
                    ? "Welcome! Click on one of the GCSE subjects below to start a test. These tests are a sample of what you would receive on one of our GCSE courses..."
                    : "Welcome! Click on one of the subjects below to start a test. These tests are a sample of what you would receive on one of our courses..."}
                </p>
              )}
              {isFreeDownloads &&
                (!isGcse ? (
                  <p className="p-4">
                    Welcome! Click on one of the tests below to download a
                    practice paper.
                  </p>
                ) : (
                  <p className="p-4">Coming Soon...</p>
                ))}
            </div>
          </>
        )}

        <div className="flex flex-col-reverse items-start justify-center xl:flex-row xl:p-4 w-full">
          <div className="flex flex-col w-full items-start xl:w-2/4 ">
            {/* Left Section */}
            {!isFreeDownloads && testData.length !== 0 && (
              <div className=" text-left flex justify-start items-center w-full mb-4">
                <h2 className={isGcse ? "text-left text-white" : "text-left"}>
                  {isGcse ? "Select GCSE Test" : "Select Test"}
                </h2>
                <div className="ml-4">
                  <FontAwesomeIcon
                    icon={faCircleInfo}
                    size="2x"
                    style={{
                      color: "blue",
                      backgroundColor: "white",
                      borderRadius: "50px",
                    }}
                    onClick={() => setShowTip((prevState) => !prevState)}
                  />
                </div>
              </div>
            )}
            {isFreeDownloads &&
              (!isGcse ? (
                <div className="text-left flex justify-start items-center w-full mb-4">
                  <h2 className=" text-left">Download A Paper</h2>
                </div>
              ) : (
                <h2 className="text-white text-left mb-4"></h2>
              ))}

            {showTip && (
              <div className="w-full">
                <WordFromTutors />
              </div>
            )}
            {!isFreeDownloads && (
              <div className="flex w-full flex-wrap xl:grid xl:grid-cols-2 xl:gap-4 mb-4">
                {testData.map((test, index) => {
                  const quizSummaryId = getProperty(test, 'quizSummaryId') || getProperty(test, 'QuizSummaryId') || test?.QuizSummaryId || test?.quizSummaryId;
                  const quizTitle = getProperty(test, 'quizTitle') || getProperty(test, 'QuizTitle') || test?.QuizTitle || test?.quizTitle || 'Test';
                  const totalCorrect = getProperty(test, 'totalCorrect') || getProperty(test, 'TotalCorrect') || test?.TotalCorrect || test?.totalCorrect || 0;
                  const totalPassed = getProperty(test, 'totalPassed') || getProperty(test, 'TotalPassed') || test?.TotalPassed || test?.totalPassed || 0;
                  const totalIncorrect = getProperty(test, 'totalIncorrect') || getProperty(test, 'TotalIncorrect') || test?.TotalIncorrect || test?.totalIncorrect || 0;
                  
                  return (
                    <TestBox
                      isGcse={isGcse}
                      key={quizSummaryId || `test-${index}`}
                      title={quizTitle}
                      testProgress={getTestProgress(test)}
                      quizSummaryId={quizSummaryId}
                      index={index}
                      isMobile={isMobile}
                      pieData={{
                        datasets: [
                          {
                            data: [
                              totalCorrect,
                              totalPassed,
                              totalIncorrect,
                            ],
                            backgroundColor: ["#9fd066", "#fdd03d", "#e74c3c"],
                          },
                        ],
                      }}
                      className={`test-box ${
                        index === 0
                          ? "red-border"
                          : index === 1
                          ? "blue-border"
                          : index === 2
                          ? "green-border"
                          : index === 3
                          ? "orange-border"
                          : "yellow-border"
                      }`}
                    />
                  );
                })}
              </div>
            )}
            {isFreeDownloads && !isGcse && (
              <div className="flex w-full flex-wrap xl:grid xl:grid-cols-2 xl:gap-4 mb-4">
                {testData && testData.length > 0 ? (
                  testData.map((test, index) => {
                    const quizTitle = getProperty(test, 'quizTitle') || getProperty(test, 'QuizTitle') || test.QuizTitle || test.quizTitle || '';
                    const { img, type } = mapQuizToPaper(quizTitle);
                    // Clean up the title - remove [FDL-YR4] prefix and format nicely
                    const cleanTitle = quizTitle.replace(/\[FDL-[^\]]+\]\s*/i, '').trim();
                    const formattedTitle = cleanTitle ? `KSOL 11+ Practice Papers | ${cleanTitle} - Suitable for the 11+ GL Assessment` : 'Free Download Paper';
                    
                    return (
                      <TestBox
                        key={getProperty(test, 'quizSummaryId') || getProperty(test, 'QuizSummaryId') || test.QuizSummaryId || test.quizSummaryId || `test-${index}`}
                        title={formattedTitle}
                        paperImg={img}
                        type={type}
                        freePapers={true}
                        isMobile={isMobile}
                      />
                    );
                  })
                ) : (
                  freePapers.map((paper, idx) => (
                    <TestBox
                      key={paper.id || `paper-${idx}`}
                      title={paper.name}
                      paperImg={paper.img}
                      type={paper.type}
                      freePapers={true}
                      isMobile={isMobile}
                    />
                  ))
                )}
              </div>
            )}
          </div>

          {/* Right Section - Make Sticky */}
          <div
            className={`w-full flex flex-col items-center justify-between mt-10 mb-10 xl:mt-20 ${
              isGcse ? "gcse-course-bg" : "course-bg"
            } drop-shadow-lg xl:w-1/4 xl:ml-4 xl:sticky xl:top-4`}
          >
            <h3
              className={
                isGcse
                  ? `mt-4 text-center text-white font-bold p-4`
                  : `mt-4 text-center  font-bold p-4`
              }
            >
              {testData && testData[0] ? (
                getProperty(testData[0], 'recommendedProduct') || 
                getProperty(testData[0], 'RecommendedProduct') || 
                "Benefits of KSOL"
              ) : (
                "Benefits of KSOL"
              )}
            </h3>
            <img
              className={
                isGcse
                  ? "hidden  xl:flex xl:w-4/5 mb-2"
                  : "hidden course-img xl:flex  "
              }
              src={isGcse ? gcseImg : courseImg}
              alt="Course"
            />
            <div className="hidden flex px-4 py-2 items-center bg-white rounded-xl justify-center xl:w-auto xl:flex">
              <img className="tick-img" src={tick} alt="Tick" />
              <p>{isGcse ? "Designed for High Achievers" : "GL Focused"}</p>
            </div>
            <div className="hidden mt-4 flex px-4 py-2 items-center bg-white rounded-xl w-11/12 justify-center xl:w-auto xl:flex">
              <img className="tick-img" src={tick} alt="Tick" />
              <p>
                {isGcse
                  ? "Ask Me Now, Tokenized Support"
                  : "Qualified Tutor Support"}
              </p>
            </div>
            <div className="hidden mt-4 flex px-4 py-2 items-center bg-white rounded-xl w-11/12 justify-center xl:w-auto xl:flex">
              <img className="tick-img" src={tick} alt="Tick" />
              <p>
                {isGcse
                  ? "Daily Tests and Explanations"
                  : "Interactive Video Lessons"}
              </p>
            </div>
            <div className="hidden mt-4 flex px-4 py-2 items-center bg-white rounded-xl justify-center xl:w-auto xl:flex mb-4">
              <img className="tick-img" src={tick} alt="Tick" />
              <p>
                {isGcse ? "Everything Needed for Maths Success" : "Daily Tests"}
              </p>
            </div>
            {testData && testData[0] && (() => {
              const recommendedCourseAmount = getProperty(testData[0], 'recommendedCourseAmount') || getProperty(testData[0], 'RecommendedCourseAmount') || testData[0]?.RecommendedCourseAmount || testData[0]?.recommendedCourseAmount;
              if (!recommendedCourseAmount) return null;
              return (
                <>
                  <div className="mb-4 mt-8 p-4 xl:p-0">
                    <CustomButton
                      text={"Enrol Now!"}
                      onClick={() => takeToCourse()}
                      isGcse={isGcse}
                      type={isMobile ? "logOut" : ""}
                    />
                  </div>
                  <div className="flex justify-center w-10/12 mb-4 text-center">
                    <a href="https://www.ksol.co.uk/contents/help/terms-and-conditions-for-purchases">
                      <p
                        className={` ${
                          isGcse ? "text-white" : "text-cyan-700"
                        } underline`}
                      >
                        *Terms and Conditions
                      </p>
                    </a>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      </div>
     
    </div>
    </>
  );
};

export default TestsScreen;
